module.exports = __webpack_public_path__ + "img/infoWhite.35402fef.gif";